var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewQuoteB1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3376_18459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.3379 29.8182C25.3379 30.2545 25.0473 30.5455 24.6115 30.5455H7.17906C6.74325 30.5455 6.45271 30.2545 6.45271 29.8182V2.18182C6.45271 1.74545 6.74325 1.45455 7.17906 1.45455H16.6216V0H7.17906C5.94426 0 5 0.945455 5 2.18182V29.8182C5 31.0545 5.94426 32 7.17906 32H24.6115C25.8463 32 26.7906 31.0545 26.7906 29.8182V10.1818H25.3379V29.8182Z",
    fill: "#47127D",
    stroke: "#47127D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4358 4.36364V0H20.9831V4.36364H16.625V5.81818H20.9831V10.1818H22.4358V5.81818H26.7939V4.36364H22.4358Z",
    fill: "#47127D",
    stroke: "#47127D",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0704 12.3635H10.8068V13.8181H18.0704V12.3635Z",
    fill: "#47127D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9758 18.1819H10.8068V19.6364H20.9758V18.1819Z",
    fill: "#47127D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0704 24H10.8068V25.4545H18.0704V24Z",
    fill: "#47127D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3376_18459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewQuoteB1);
export default __webpack_public_path__ + "static/media/NewQuote_B 1.78640efa3a51823cd89c42fcceb59fbb.svg";
export { ForwardRef as ReactComponent };